import React from 'react';

export default () => {
    return (
        <React.Fragment>
            <div className="lds-css ng-scope" style={{width:'200px', height: '200px', margin: '0 auto'}}><div style={{width:'100%', height:'100%'}} className="lds-eclipse"><div></div></div></div>
        </React.Fragment>
    )
}
